import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/course-action-types';

import type {List, Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CourseStore = {
    activity: List<Map<string, string>>;
};

export const initialState = (): CourseStore => {
    return {
        activity: Immutable.List(),
    };
};

export const actionsMap: ActionsMap<CourseStore> = {
    [actionTypes.GET_COURSE_ACTIVITY_SUCCESS]: (state, action) => {
        return {
            activity: action.data,
        };
    },
};

export default createReducer<CourseStore>(initialState(), actionsMap);
